export const bankTransactionFields = {
  Bank: "Banco",
  AccountHolder: "Titular de la cuenta",
  IBAN: "IBAN",
  TransactionReference: "Referencia de la transacción",
  OpeningBalance: "Saldo inicial",
  Debit: "Débito",
  Credit: "Crédito",
  ClosingBalance: "Saldo final",
  TransactionDate: "Fecha de la transacción",
  SyncDate: "Fecha de sincronización",
};
